import { FormExtraParams } from '../types';

export const formController = {
  // Find parent hidden inputs and return them if found.
  getParentHiddenInputs: function (el: HTMLElement | null): FormExtraParams {
    let inputAttr: FormExtraParams = {};

    while (el?.parentNode) {
      el = el.parentNode as HTMLElement;
      const inputTags = el.querySelectorAll<HTMLInputElement>('input[data-mz-form-field-name]');

      if (inputTags.length > 0) {
        inputTags.forEach(input => {
          const name = input.getAttribute('data-mz-form-field-name');
          if (name) {
            const nameTrimmed = name.trim();
            inputAttr = {
              ...inputAttr,
              [nameTrimmed]: input.value
            };
          }
        });
        return inputAttr;
      }
    }

    return inputAttr;
  },
};
